import { FeatureFlag } from '@ps/web-core-enums';
import { type RootState, select } from '@ps/web-core-store';
import type { Selector } from 'react-redux';
import { createSelector } from 'reselect';

import { withEventBasedMarketTemplateModelSelectors } from '@swf/sports/models/market-templates/eventBased';

import { defaultState } from './defaultState';

export const selectors = withEventBasedMarketTemplateModelSelectors(defaultState, (slice) => ({
  hasPreloaded: () => slice((state) => state.hasPreloaded),
  isLoading: () => slice((state) => state.isLoading),
  hasErrored: () => slice((state) => state.error),
  popularEvents: () => slice((state) => state.popularEvents),
  hasPopularEvents: () => slice((state) => Boolean(state.popularEvents.length)),
  inPlayEvents: () => slice((state) => state.inPlayEvents),
  hasInPlayEvents: () => slice((state) => Boolean(state.inPlayEvents.length)),
  oddsBoostEvents: () => slice((state) => state.popularOddsBoostEvents),
  hasOddsBoostEvents: () => slice((state) => Boolean(state.popularOddsBoostEvents.length)),
  popularBetBuilders: () => slice((state) => state.popularBetBuilders),
  hasPopularBetBuilders: () => slice((state) => Boolean(state.popularBetBuilders.length)),
  popularCompetitions: () => slice((state) => state.popularCompetitions),
  hasPopularCompetitions: () => slice((state) => Boolean(state.popularCompetitions.length)),
  popularAccumulators: () => slice((state) => state.popularAccumulators),
  hasPopularAccumulators: () => slice((state) => Boolean(state.popularAccumulators.length))
}));
